import { render, staticRenderFns } from "./SectionResultat.vue?vue&type=template&id=6c0c48b2&scoped=true&"
import script from "./SectionResultat.vue?vue&type=script&lang=js&"
export * from "./SectionResultat.vue?vue&type=script&lang=js&"
import style0 from "./SectionResultat.vue?vue&type=style&index=0&id=6c0c48b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c48b2",
  null
  
)

export default component.exports